import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Shown when a staff persona lacks the permission a section needs.
 *
 * Says what happened rather than pretending the section does not exist: the
 * person reading this is a colleague, and "you don't have access" plus how to
 * get it is more useful than a 404 that makes them doubt the URL.
 */
export function Forbidden() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-prose py-12">
      <h1 className="text-xl font-semibold">{t('forbidden.title')}</h1>
      <p className="mt-2 text-sm text-[var(--color-muted-foreground)]">
        {t('forbidden.description')}
      </p>
      <Link className="mt-4 inline-block text-sm underline" to="/">
        {t('forbidden.back')}
      </Link>
    </div>
  );
}
